import React from 'react';

import Tooltip from '@dashboard/components/Tooltip';
import { getPageTitle } from '@dashboard/lib/pageTitle';

/** A record's page by the title customers see; the seller's own name for it shows on hover. */
export default function PageTitle({ page }) {
  const title = getPageTitle(page);
  if (!title) return null;
  if (!page?.name || page.name === title) return title;

  return (
    <Tooltip label={`Name: ${page.name}`} asChild>
      <span className="relative z-10 cursor-default">{title}</span>
    </Tooltip>
  );
}
